<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template>
	<div class="d-flex justify-center align-center">
		<MiniNav v-show="!site_config.use_vx_nav && admin_tool_showing" current_section="admin"/>

		<div class="k-main-collection" :class="admin_tool_showing?'k-main-collection--item-showing k-main-collection--admin-showing':''">
			<div class="k-main-collection-header">
				<component :is="admin_tool_showing ? 'div' : 'h1'" class="k-page-title d-flex">
					<k-icon large color="primary" class="mr-4" style="margin-top: -2px">{{ config.icon }}</k-icon>
					<b>{{ config.title }}</b>
					<k-spacer/>
				</component>
			</div>

			<div class="k-main-collection-body">
				<div
					v-if="show_admin_tool_option('users')"
					class="k-elevated k-main-collection-item pb-5 pt-7 justify-space-between white--text k-admin-tile-button"
					:style=" { 'background-color':'#c62828' }"
					:class="admin_tool_showing=='users'?'k-admin-item-showing':''"
					role="button"
					tabindex="0"
					aria-label="Open Manage User Accounts admin tool"
					@click="go_to_admin_route('users')"
					@keydown="admin_tile_keydown($event, 'users')"
				>
					<div>
						<b>Manage User Accounts</b>
					</div>

					<div>
						<k-icon large color="#fff">fas fa-user-cog</k-icon>
					</div>
				</div>

				<div
					v-if="show_admin_tool_option('home_page')"
					class="k-elevated k-main-collection-item pb-5 pt-7 justify-space-between white--text k-admin-tile-button"
					:style=" { 'background-color':'#ad1457' }"
					:class="admin_tool_showing=='home_page'?'k-admin-item-showing':''"
					role="button"
					tabindex="0"
					aria-label="Open Home Page Content admin tool"
					@click="go_to_admin_route('home_page')"
					@keydown="admin_tile_keydown($event, 'home_page')"
				>
					<div>
						<b>Home Page Content</b>
					</div>

					<div>
						<k-icon large color="#fff">fas fa-home</k-icon>
					</div>
				</div>

				<div
					v-if="show_admin_tool_option('lp')"
					class="k-elevated k-main-collection-item pb-5 pt-7 justify-space-between white--text k-admin-tile-button"
					:style="{ 'background-color':'#6A1B9A' }"
					:class="admin_tool_showing=='lp'?'k-admin-item-showing':''"
					role="button"
					tabindex="0"
					aria-label="Open Content Collections admin tool"
					@click="go_to_admin_route('lp')"
					@keydown="admin_tile_keydown($event, 'lp')"
				>
					<div>
						<b>Content Collections</b>
					</div>

					<div>
						<k-icon large color="#fff">fas fa-chalkboard</k-icon>
					</div>
				</div>

				<div
					v-if="show_admin_tool_option('editlog')"
					class="k-elevated k-main-collection-item pb-5 pt-7 justify-space-between white--text k-admin-tile-button"
					:class="admin_tool_showing=='editlog'?'k-admin-item-showing':''"
					:style="{ 'background-color':'#4527a0' }"
					role="button"
					tabindex="0"
					aria-label="Open Course Editing Logs admin tool"
					@click="go_to_admin_route('editlog')"
					@keydown="admin_tile_keydown($event, 'editlog')"
				>
					<div>
						<b>Course Editing Logs</b>
					</div>

					<div>
						<k-icon large color="#fff">fas fa-person-digging</k-icon>
					</div>
				</div>

				<div
					v-if="show_admin_tool_option('lti')"
					class="k-elevated k-main-collection-item pb-5 pt-7 justify-space-between white--text k-admin-tile-button"
					:style="{ 'background-color':'#283593' }"
					:class="admin_tool_showing=='lti'?'k-admin-item-showing':''"
					role="button"
					tabindex="0"
					:aria-label="`Open ${site_config.subdomain_admin_title} admin tool`"
					@click="go_to_admin_route('lti')"
					@keydown="admin_tile_keydown($event, 'lti')"
				>
					<div>
						<b>{{site_config.subdomain_admin_title}}</b>
					</div>

					<div>
						<k-icon large color="#fff">fas fa-school</k-icon>
					</div>
				</div>

				<div
					v-if="show_admin_tool_option('usage')"
					class="k-elevated k-main-collection-item pb-5 pt-7 justify-space-between white--text k-admin-tile-button"
					:class="admin_tool_showing=='usage'?'k-admin-item-showing':''"
					:style="{ 'background-color': '#0277bd' }"
					role="button"
					tabindex="0"
					aria-label="Open Site Usage Stats admin tool"
					@click="go_to_admin_route('usage')"
					@keydown="admin_tile_keydown($event, 'usage')"
				>
					<div>
						<b>Site Usage Stats</b>
					</div>

					<div>
						<k-icon large color="#fff">fas fa-chart-line</k-icon>
					</div>
				</div>

				<div
					v-if="show_admin_tool_option('resource_usage')"
					class="k-elevated k-main-collection-item pb-5 pt-7 justify-space-between white--text k-admin-tile-button"
					:class="admin_tool_showing=='resource_usage'?'k-admin-item-showing':''"
					:style="{'background-color': '#00838f'}"
					role="button"
					tabindex="0"
					aria-label="Open Resource Usage Report admin tool"
					@click="go_to_admin_route('resource_usage')"
					@keydown="admin_tile_keydown($event, 'resource_usage')"
				>
					<div>
						<b>Resource Usage Report</b>
					</div>

					<div>
						<k-icon large color="#fff">fas fa-table</k-icon>
					</div>
				</div>

				<div
					v-if="show_admin_tool_option('site_issue_reports')"
					class="k-elevated k-main-collection-item pb-5 pt-7 justify-space-between white--text k-admin-tile-button"
					:class="admin_tool_showing=='site_issue_reports'?'k-admin-item-showing':''"
					:style="{ 'background-color': '#827717' }"
					role="button"
					tabindex="0"
					aria-label="Open Site Issue Reports admin tool"
					@click="go_to_admin_route('site_issue_reports')"
					@keydown="admin_tile_keydown($event, 'site_issue_reports')"
				>
					<div>
						<b>Site Issue Reports</b>
					</div>

					<div>
						<k-icon large color="#fff">fas fa-bug</k-icon>
					</div>
				</div>

				<div
					v-if="show_admin_tool_option('terms')"
					class="k-elevated k-main-collection-item pb-5 pt-7 justify-space-between white--text k-admin-tile-button"
					:class="admin_tool_showing == 'terms' ? 'k-admin-item-showing' : ''"
					:style="{ 'background-color': '#EF6C00' }"
					role="button"
					tabindex="0"
					aria-label="Open Term Management admin tool"
					@click="go_to_admin_route('terms')"
					@keydown="admin_tile_keydown($event, 'terms')"
				>
					<div>
						<b>Term Management</b>
					</div>

					<div>
						<k-icon large color="#fff">fas fa-calendar</k-icon>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState} from 'vuex'
import MiniNav from '../main/MiniNav'

export default {
	components: { MiniNav },

	props: {
		config: {type: Object, required: true}
	},
	
	computed: {
		...mapState(['user_info', 'site_config', 'tools_for_subdomain_admins']),

		admin_tool_showing() {
			if (this.$route.fullPath.search(/admin\/(\w+)\b/) > -1) {
				return RegExp.$1
			} else {
				return null
			}
		},
	},
	
	methods: {
		admin_tile_keydown(event, which) {
			if (event.key !== 'Enter' && event.key !== ' ') return
			event.preventDefault()
			this.go_to_admin_route(which)
		},

		show_admin_tool_option(tool) {
			// some tools have special rules (e.g. site_config options)

			if (tool == 'lti') {
				// for lti/agencies tool, at least one of these site_configs must be on...
				if (!(this.site_config.enable_admin_lti_management === 'yes' || this.site_config.enable_subdomains === 'yes')) return false

			} else if (tool == 'site_issue_reports') {
				// site issue reports are also used for the enhanced lesson plan editor
				if (!(this.site_config.show_submit_feedback_option_for_resources === 'yes' || this.site_config.enable_llm_lesson_plans != 'no')) return false

			} else if (tool == 'terms') {
				if (this.site_config.enable_admin_term_management !== 'yes') return false

			}
			
			if (this.tools_for_subdomain_admins.includes(tool)) {
				// subdomain admins can see these tools (but will have limited rights on those tools)
				if (vapp.has_admin_right('subdomain_admin')) return true
			}

			// if we get to here, show iff the user's role is 'admin'
			return this.user_info.role == 'admin'
		},

		go_to_admin_route(which) {
			this.$router.push({ path: '/admin/' + which })
		},
	}
}
</script>

<style lang="scss">
.k-main-wrapper .k-main-collection--admin-showing {
	display: inline-block;
	padding: 0 10px !important;
	overflow: auto;

	.k-main-collection-header {
		display: none !important;
	}

	.k-main-collection-body {
		flex-wrap: nowrap;
	}

	.k-main-collection-item {
		width: 120px;
		height: 120px;
		border-radius: 16px;
		opacity: 0.6;
		margin: 18px 8px;
		background-color: #f8f8f8;
		font-size: 13px !important;
		line-height: 16px;

		.v-icon {
			font-size: 20px !important;
		}
	}

	.k-admin-item-showing {
		opacity: 1.0 !important;
	}
}

.k-admin-tile-button {
	outline: none;
}

.k-admin-tile-button:focus-visible {
	outline: 3px solid #ffffff;
	outline-offset: 3px;
	box-shadow: 0 0 0 2px #0d47a1, 0 0 0 5px #ffffff, 0 0 0 7px #0d47a1;
}
</style>
